export default [
  {
    path: '/personal-center',
    meta: { layout: 'PersonalCenter', workbenchTitle: '个人中心' },
    children: [
      {
        path: '',
        redirect: '/personal-center/home'
      },

      {
        path: 'home',
        name: 'PersonalCenterHome',
        component: () => import('@/views/personal-center/home.vue'),
        meta: {
          title: '我的主页',
          index: 3
        }
      },

      {
        path: 'joined-company',
        name: 'JoinedCompany',
        component: () => import('@/views/personal-center/joined-company.vue'),
        meta: {
          title: '企业管理',
          index: 4
        }
      },

      {
        path: 'value-added-services',
        name: 'ValueAddedServices',
        meta: {
          title: '会员中心',
          index: 4
        },
        children: [
          {
            path: 'vip-home',
            name: 'VipHome',
            component: () =>
              import(
                '@/views/personal-center/value-added-services/vip-home.vue'
              ),
            meta: { index: 5, title: '会员主页' }
          },
          {
            path: 'portrait-record',
            name: 'PortraitRecord',
            component: resolve =>
              require([
                '@/views/personal-center/value-added-services/portrait-record.vue'
              ], resolve),
            meta: {
              index: 5,
              title: '分析记录',
              sectionTitle: '个人中心',
              layout: 'PersonalCenter'
            }
          },
          {
            path: 'bid-file-preview',
            name: 'BidFilePreview',
            component: () =>
              import(
                '@/views/personal-center/value-added-services/bid-file-preview.vue'
              ),
            meta: {
              index: 5,
              title: '标书预览记录'
            }
          },
          {
            path: 'custom-data',
            name: 'CustomData',
            component: resolve =>
              require([
                '@/views/personal-center/value-added-services/custom-data.vue'
              ], resolve),
            meta: {
              index: 5,
              title: '数据导出记录',
              sectionTitle: '个人中心',
              layout: 'PersonalCenter'
            }
          }
        ]
      },

      {
        path: 'expense-billing',
        name: 'ExpenseBilling',
        component: () => import('@/views/personal-center/expense-billing.vue'),
        meta: {
          title: '费用账单',
          index: 4
        }
      },

      {
        path: 'invoice',
        name: 'Invoice',
        meta: {
          title: '发票管理',
          index: 4
        },
        children: [
          {
            path: 'list',
            name: 'InvoiceList',
            component: () =>
              import('@/views/personal-center/invoice/invoice-list.vue'),
            meta: {
              index: 5,
              title: '发票记录'
            }
          },
          {
            path: 'helper',
            name: 'InvoiceHelper',
            component: () =>
              import('@/views/personal-center/invoice/invoice-helper.vue'),
            meta: {
              index: 5,
              title: '发票助手'
            }
          }
        ]
      },

      {
        path: 'guarantee',
        name: 'Guarantee',
        component: () => import('@/views/personal-center/guarantee.vue'),
        meta: {
          title: '异常保证金查询',
          index: 4,
          identity: ['purchase']
        }
      },

      {
        path: 'basic-setting',
        name: 'BasicSetting',
        component: () => import('@/views/personal-center/basic-setting.vue'),
        meta: {
          title: '基础设置',
          index: 4
        }
      },

      {
        path: 'security-setting',
        name: 'SecuritySetting',
        component: () => import('@/views/personal-center/security-setting.vue'),
        meta: {
          title: '安全设置',
          index: 4
        }
      }
    ]
  }
]
